
const Employee = (state) => state.Employee;
const Employees = (state) => state.Employees;
const TotalInfo = (state) => state.TotalInfo;
export default { Employee, Employees, TotalInfo }